import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
    GET_ALL_COACHES
} from "../constants/ActionTypes";

import {
    getAllCoachesSuccess,
    getAllcoachesError
} from "../actions/CoachAction";

import { userSignOut } from '../actions/Auth'

import { getcoachesApi } from "../api/CoachApi";

function* getAllCoachesData({ payload }) {
    const { sessionToken } = payload
    try {
        const coaches = yield call(getcoachesApi, sessionToken);
        if (coaches.code) {
            if (coaches.code === 401) {
                yield put(userSignOut());
            } else {
                yield put(getAllcoachesError(coaches));
            }
        } else {
            console.log("coaches : " + coaches);
            yield put(getAllCoachesSuccess(coaches));
        }

    } catch (error) {
        console.log("coaches error : " + error);
        yield put(getAllcoachesError(error));
    }
}

export function* getCoaches() {
    yield takeEvery(GET_ALL_COACHES, getAllCoachesData);
}

export default function* rootSaga() {
    yield all([fork(getCoaches)]);
}